// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetData, AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors, AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetResponses, CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostData, CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors, CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses, CreateApiKeyUserApiKeyPostData, CreateApiKeyUserApiKeyPostErrors, CreateApiKeyUserApiKeyPostResponses, CreateUserUserPostData, CreateUserUserPostErrors, CreateUserUserPostResponses, DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteData, DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors, DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteResponses, DeleteUserUserUserIdDeleteData, DeleteUserUserUserIdDeleteErrors, DeleteUserUserUserIdDeleteResponses, ExchangeTokenIntegrationsOauth2ClientTokenPostData, ExchangeTokenIntegrationsOauth2ClientTokenPostErrors, ExchangeTokenIntegrationsOauth2ClientTokenPostResponses, GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostData, GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors, GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostResponses, GetAllPlatformUsersUserAllGetData, GetAllPlatformUsersUserAllGetErrors, GetAllPlatformUsersUserAllGetResponses, GetDomainRolesUserUserIdDomainRolesGetData, GetDomainRolesUserUserIdDomainRolesGetErrors, GetDomainRolesUserUserIdDomainRolesGetResponses, GetFirebaseUserByEmailUserFirebaseEmailGetData, GetFirebaseUserByEmailUserFirebaseEmailGetErrors, GetFirebaseUserByEmailUserFirebaseEmailGetResponses, GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetData, GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors, GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses, GetOauthMetadataWellKnownOauthAuthorizationServerGetData, GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses, GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetData, GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses, GetPolicyAcceptancesUserPolicyAcceptancesGetData, GetPolicyAcceptancesUserPolicyAcceptancesGetErrors, GetPolicyAcceptancesUserPolicyAcceptancesGetResponses, GetPolicyStatusUserPolicyStatusGetData, GetPolicyStatusUserPolicyStatusGetResponses, GetSelfUserMeGetData, GetSelfUserMeGetResponses, GetUsersUserGetData, GetUsersUserGetResponses, ListApiKeysUserApiKeysGetData, ListApiKeysUserApiKeysGetResponses, McpStreamableHttpHandlerIntegrationsMcpPost2Data, McpStreamableHttpHandlerIntegrationsMcpPost2Responses, McpStreamableHttpHandlerIntegrationsMcpPost3Data, McpStreamableHttpHandlerIntegrationsMcpPost3Responses, McpStreamableHttpHandlerIntegrationsMcpPostData, McpStreamableHttpHandlerIntegrationsMcpPostResponses, PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetData, PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors, PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses, PreviewLinkProxyPreviewLinkGetData, PreviewLinkProxyPreviewLinkGetErrors, PreviewLinkProxyPreviewLinkGetResponses, RecordPolicyAcceptanceUserPolicyAcceptancePostData, RecordPolicyAcceptanceUserPolicyAcceptancePostErrors, RecordPolicyAcceptanceUserPolicyAcceptancePostResponses, RegisterClientIntegrationsOauth2ServerRegisterPostData, RegisterClientIntegrationsOauth2ServerRegisterPostErrors, RegisterClientIntegrationsOauth2ServerRegisterPostResponses, ResendInvitationEndpointUserUserIdResendInvitationPostData, ResendInvitationEndpointUserUserIdResendInvitationPostErrors, ResendInvitationEndpointUserUserIdResendInvitationPostResponses, RevokeApiKeyUserApiKeyApiKeyIdDeleteData, RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors, RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses, RevokeTokenIntegrationsOauth2ServerRevokePostData, RevokeTokenIntegrationsOauth2ServerRevokePostErrors, RevokeTokenIntegrationsOauth2ServerRevokePostResponses, SearchSearchGetData, SearchSearchGetErrors, SearchSearchGetResponses, SignupUserSignupPostData, SignupUserSignupPostErrors, SignupUserSignupPostResponses, SignupWithInvitationUserSignupWithInvitationPostData, SignupWithInvitationUserSignupWithInvitationPostErrors, SignupWithInvitationUserSignupWithInvitationPostResponses, StartAiEvaluationGetTaskEvaluationsStartPostData, StartAiEvaluationGetTaskEvaluationsStartPostErrors, StartAiEvaluationGetTaskEvaluationsStartPostResponses, StartAiTaskMgtGetTaskProvidersStartPostData, StartAiTaskMgtGetTaskProvidersStartPostErrors, StartAiTaskMgtGetTaskProvidersStartPostResponses, StartAiTaskMgtRunTaskStartPostData, StartAiTaskMgtRunTaskStartPostErrors, StartAiTaskMgtRunTaskStartPostResponses, StartBizArtefactManagementAddArtefactGroupStartPostData, StartBizArtefactManagementAddArtefactGroupStartPostErrors, StartBizArtefactManagementAddArtefactGroupStartPostResponses, StartBizArtefactManagementAddArtefactStartPostData, StartBizArtefactManagementAddArtefactStartPostErrors, StartBizArtefactManagementAddArtefactStartPostResponses, StartBizArtefactManagementGetArtefactStartPostData, StartBizArtefactManagementGetArtefactStartPostErrors, StartBizArtefactManagementGetArtefactStartPostResponses, StartBizArtefactManagementGetArtefactsTreeStartPostData, StartBizArtefactManagementGetArtefactsTreeStartPostErrors, StartBizArtefactManagementGetArtefactsTreeStartPostResponses, StartBizArtefactManagementGetHistoryStartPostData, StartBizArtefactManagementGetHistoryStartPostErrors, StartBizArtefactManagementGetHistoryStartPostResponses, StartBizArtefactManagementRemoveArtefactGroupStartPostData, StartBizArtefactManagementRemoveArtefactGroupStartPostErrors, StartBizArtefactManagementRemoveArtefactGroupStartPostResponses, StartBizArtefactManagementRemoveArtefactStartPostData, StartBizArtefactManagementRemoveArtefactStartPostErrors, StartBizArtefactManagementRemoveArtefactStartPostResponses, StartBizArtefactManagementRenameArtefactGroupStartPostData, StartBizArtefactManagementRenameArtefactGroupStartPostErrors, StartBizArtefactManagementRenameArtefactGroupStartPostResponses, StartBizArtefactManagementRenameArtefactStartPostData, StartBizArtefactManagementRenameArtefactStartPostErrors, StartBizArtefactManagementRenameArtefactStartPostResponses, StartBizArtefactManagementRestoreHistoricalArtefactStartPostData, StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors, StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponses, StartBizArtefactManagementUpdateArtefactContentStartPostData, StartBizArtefactManagementUpdateArtefactContentStartPostErrors, StartBizArtefactManagementUpdateArtefactContentStartPostResponses, StartBizArtefactManagementUpdateArtefactStartPostData, StartBizArtefactManagementUpdateArtefactStartPostErrors, StartBizArtefactManagementUpdateArtefactStartPostResponses, StartBizEntitiesEntityTypeEntityIdAttributeGetData, StartBizEntitiesEntityTypeEntityIdAttributeGetErrors, StartBizEntitiesEntityTypeEntityIdAttributeGetResponses, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponses, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostErrors, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponses, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses, StartBizEntitiesEntityTypeEntityIdInfoGetData, StartBizEntitiesEntityTypeEntityIdInfoGetErrors, StartBizEntitiesEntityTypeEntityIdInfoGetResponses, StartDashboardDashboardMgtGetDashboardsByStekStartPostData, StartDashboardDashboardMgtGetDashboardsByStekStartPostResponses, StartDashboardDashboardMgtUpdateDashboardStartPostData, StartDashboardDashboardMgtUpdateDashboardStartPostErrors, StartDashboardDashboardMgtUpdateDashboardStartPostResponses, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponses, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponses, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses, StartDomainBusinessEntityMgtGetBusinessEntityStartPostData, StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors, StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponses, StartDomainDomainMgtCreateDomainStartPostData, StartDomainDomainMgtCreateDomainStartPostErrors, StartDomainDomainMgtCreateDomainStartPostResponses, StartDomainDomainMgtDeleteDomainStartPostData, StartDomainDomainMgtDeleteDomainStartPostErrors, StartDomainDomainMgtDeleteDomainStartPostResponses, StartDomainDomainMgtGetDomainsByStekStartPostData, StartDomainDomainMgtGetDomainsByStekStartPostResponses, StartDomainDomainMgtGetDomainStartPostData, StartDomainDomainMgtGetDomainStartPostErrors, StartDomainDomainMgtGetDomainStartPostResponses, StartDomainDomainMgtUpdateDomainOrdersStartPostData, StartDomainDomainMgtUpdateDomainOrdersStartPostErrors, StartDomainDomainMgtUpdateDomainOrdersStartPostResponses, StartDomainDomainMgtUpdateDomainStartPostData, StartDomainDomainMgtUpdateDomainStartPostErrors, StartDomainDomainMgtUpdateDomainStartPostResponses, StartDomainRoleMgtCreateRoleStartPostData, StartDomainRoleMgtCreateRoleStartPostErrors, StartDomainRoleMgtCreateRoleStartPostResponses, StartDomainRoleMgtDeleteRoleStartPostData, StartDomainRoleMgtDeleteRoleStartPostErrors, StartDomainRoleMgtDeleteRoleStartPostResponses, StartDomainRoleMgtGetRolesStartPostData, StartDomainRoleMgtGetRolesStartPostErrors, StartDomainRoleMgtGetRolesStartPostResponses, StartDomainRoleMgtGetRoleStartPostData, StartDomainRoleMgtGetRoleStartPostErrors, StartDomainRoleMgtGetRoleStartPostResponses, StartDomainRoleMgtUpdateRoleStartPostData, StartDomainRoleMgtUpdateRoleStartPostErrors, StartDomainRoleMgtUpdateRoleStartPostResponses, StartOrganizationActivityMetricsGetOrganizationActivityStartGetData, StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors, StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses, StartOrganizationOrganizationMgtGetOrganizationsStartPostData, StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses, StartProcessLaneMgtGetLaneByBpmnIdStartPostData, StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors, StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses, StartProcessLaneMgtGetLaneByRoleIdStartPostData, StartProcessLaneMgtGetLaneByRoleIdStartPostErrors, StartProcessLaneMgtGetLaneByRoleIdStartPostResponses, StartProcessLaneMgtGetLanesByProcessStartPostData, StartProcessLaneMgtGetLanesByProcessStartPostErrors, StartProcessLaneMgtGetLanesByProcessStartPostResponses, StartProcessLaneMgtGetLaneStartPostData, StartProcessLaneMgtGetLaneStartPostErrors, StartProcessLaneMgtGetLaneStartPostResponses, StartProcessProcessElementMgtArchiveProcessElementStartPostData, StartProcessProcessElementMgtArchiveProcessElementStartPostErrors, StartProcessProcessElementMgtArchiveProcessElementStartPostResponses, StartProcessProcessElementMgtDeleteEventStartPostData, StartProcessProcessElementMgtDeleteEventStartPostErrors, StartProcessProcessElementMgtDeleteEventStartPostResponses, StartProcessProcessElementMgtDeleteFlowStartPostData, StartProcessProcessElementMgtDeleteFlowStartPostErrors, StartProcessProcessElementMgtDeleteFlowStartPostResponses, StartProcessProcessElementMgtDeleteGatewayStartPostData, StartProcessProcessElementMgtDeleteGatewayStartPostErrors, StartProcessProcessElementMgtDeleteGatewayStartPostResponses, StartProcessProcessElementMgtDeleteTaskStartPostData, StartProcessProcessElementMgtDeleteTaskStartPostErrors, StartProcessProcessElementMgtDeleteTaskStartPostResponses, StartProcessProcessElementMgtGenerateUserInterfaceStartPostData, StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors, StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses, StartProcessProcessElementMgtGetEventStartPostData, StartProcessProcessElementMgtGetEventStartPostErrors, StartProcessProcessElementMgtGetEventStartPostResponses, StartProcessProcessElementMgtGetFlowStartPostData, StartProcessProcessElementMgtGetFlowStartPostErrors, StartProcessProcessElementMgtGetFlowStartPostResponses, StartProcessProcessElementMgtGetGatewayStartPostData, StartProcessProcessElementMgtGetGatewayStartPostErrors, StartProcessProcessElementMgtGetGatewayStartPostResponses, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses, StartProcessProcessElementMgtGetTaskStartPostData, StartProcessProcessElementMgtGetTaskStartPostErrors, StartProcessProcessElementMgtGetTaskStartPostResponses, StartProcessProcessElementMgtUnarchiveProcessElementStartPostData, StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors, StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponses, StartProcessProcessElementMgtUpdateEventStartPostData, StartProcessProcessElementMgtUpdateEventStartPostErrors, StartProcessProcessElementMgtUpdateEventStartPostResponses, StartProcessProcessElementMgtUpdateFlowStartPostData, StartProcessProcessElementMgtUpdateFlowStartPostErrors, StartProcessProcessElementMgtUpdateFlowStartPostResponses, StartProcessProcessElementMgtUpdateGatewayStartPostData, StartProcessProcessElementMgtUpdateGatewayStartPostErrors, StartProcessProcessElementMgtUpdateGatewayStartPostResponses, StartProcessProcessElementMgtUpdateTaskStartPostData, StartProcessProcessElementMgtUpdateTaskStartPostErrors, StartProcessProcessElementMgtUpdateTaskStartPostResponses, StartProcessProcessMgtCreateProcessStartPostData, StartProcessProcessMgtCreateProcessStartPostErrors, StartProcessProcessMgtCreateProcessStartPostResponses, StartProcessProcessMgtDeleteProcessStartPostData, StartProcessProcessMgtDeleteProcessStartPostErrors, StartProcessProcessMgtDeleteProcessStartPostResponses, StartProcessProcessMgtDeployProcessStartPostData, StartProcessProcessMgtDeployProcessStartPostErrors, StartProcessProcessMgtDeployProcessStartPostResponses, StartProcessProcessMgtGenerateDefinitionXmlStartPostData, StartProcessProcessMgtGenerateDefinitionXmlStartPostErrors, StartProcessProcessMgtGenerateDefinitionXmlStartPostResponses, StartProcessProcessMgtGetProcessesByProductStartPostData, StartProcessProcessMgtGetProcessesByProductStartPostErrors, StartProcessProcessMgtGetProcessesByProductStartPostResponses, StartProcessProcessMgtGetProcessStartPostData, StartProcessProcessMgtGetProcessStartPostErrors, StartProcessProcessMgtGetProcessStartPostResponses, StartProcessProcessMgtMoveProcessStartPostData, StartProcessProcessMgtMoveProcessStartPostErrors, StartProcessProcessMgtMoveProcessStartPostResponses, StartProcessProcessMgtUpdateProcessOrdersStartPostData, StartProcessProcessMgtUpdateProcessOrdersStartPostErrors, StartProcessProcessMgtUpdateProcessOrdersStartPostResponses, StartProcessProcessMgtUpdateProcessStartPostData, StartProcessProcessMgtUpdateProcessStartPostErrors, StartProcessProcessMgtUpdateProcessStartPostResponses, StartProductProductMgtCreateProductStartPostData, StartProductProductMgtCreateProductStartPostErrors, StartProductProductMgtCreateProductStartPostResponses, StartProductProductMgtDeleteProductStartPostData, StartProductProductMgtDeleteProductStartPostErrors, StartProductProductMgtDeleteProductStartPostResponses, StartProductProductMgtGetProductsByDomainStartPostData, StartProductProductMgtGetProductsByDomainStartPostErrors, StartProductProductMgtGetProductsByDomainStartPostResponses, StartProductProductMgtGetProductStartPostData, StartProductProductMgtGetProductStartPostErrors, StartProductProductMgtGetProductStartPostResponses, StartProductProductMgtMoveProductStartPostData, StartProductProductMgtMoveProductStartPostErrors, StartProductProductMgtMoveProductStartPostResponses, StartProductProductMgtUpdateProductOrdersStartPostData, StartProductProductMgtUpdateProductOrdersStartPostErrors, StartProductProductMgtUpdateProductOrdersStartPostResponses, StartProductProductMgtUpdateProductStartPostData, StartProductProductMgtUpdateProductStartPostErrors, StartProductProductMgtUpdateProductStartPostResponses, StartStekLiveMgtGetComplianceEvidenceStartPostData, StartStekLiveMgtGetComplianceEvidenceStartPostErrors, StartStekLiveMgtGetComplianceEvidenceStartPostResponses, StartStekLiveMgtGetMetricsStartPostData, StartStekLiveMgtGetMetricsStartPostErrors, StartStekLiveMgtGetMetricsStartPostResponses, StartStekLiveMgtGetProcessInstancesStartPostData, StartStekLiveMgtGetProcessInstancesStartPostErrors, StartStekLiveMgtGetProcessInstancesStartPostResponses, StartStekLiveMgtGetReleasesStartPostData, StartStekLiveMgtGetReleasesStartPostResponses, StartStekLiveMgtIngestEventStartPostData, StartStekLiveMgtIngestEventStartPostErrors, StartStekLiveMgtIngestEventStartPostResponses, StartStekStekMgtCreateStekStartPostData, StartStekStekMgtCreateStekStartPostErrors, StartStekStekMgtCreateStekStartPostResponses, StartStekStekMgtDeleteStekStartPostData, StartStekStekMgtDeleteStekStartPostResponses, StartStekStekMgtExportStekStartPostData, StartStekStekMgtExportStekStartPostResponses, StartStekStekMgtGenerateStekDetailsStartPostData, StartStekStekMgtGenerateStekDetailsStartPostErrors, StartStekStekMgtGenerateStekDetailsStartPostResponses, StartStekStekMgtGetSteksByOrganizationStartPostData, StartStekStekMgtGetSteksByOrganizationStartPostResponses, StartStekStekMgtGetStekStartPostData, StartStekStekMgtGetStekStartPostResponses, StartStekStekMgtImportStekStartPostData, StartStekStekMgtImportStekStartPostErrors, StartStekStekMgtImportStekStartPostResponses, StartStekStekMgtManageStekStartPostData, StartStekStekMgtManageStekStartPostErrors, StartStekStekMgtManageStekStartPostResponses, StartStekStekMgtTreeStartPostData, StartStekStekMgtTreeStartPostErrors, StartStekStekMgtTreeStartPostResponses, StartStekStekMgtUpdateStekStartPostData, StartStekStekMgtUpdateStekStartPostErrors, StartStekStekMgtUpdateStekStartPostResponses, StartStekStekReleaseMgtCreateReleaseStartPostData, StartStekStekReleaseMgtCreateReleaseStartPostErrors, StartStekStekReleaseMgtCreateReleaseStartPostResponses, StartStekStekReleaseMgtGetReleaseDiffStartPostData, StartStekStekReleaseMgtGetReleaseDiffStartPostErrors, StartStekStekReleaseMgtGetReleaseDiffStartPostResponses, StartStekStekReleaseMgtGetReleaseStartPostData, StartStekStekReleaseMgtGetReleaseStartPostErrors, StartStekStekReleaseMgtGetReleaseStartPostResponses, StartStekStekReleaseMgtListReleasesStartPostData, StartStekStekReleaseMgtListReleasesStartPostResponses, StartWorkspaceWorktreeMgtGetWorktreeStartPostData, StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors, StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses, TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostData, TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors, TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostResponses, TokenEndpointIntegrationsOauth2ServerTokenPostData, TokenEndpointIntegrationsOauth2ServerTokenPostErrors, TokenEndpointIntegrationsOauth2ServerTokenPostResponses, UpdateAuthorizationUserUserIdAuthorizationPutData, UpdateAuthorizationUserUserIdAuthorizationPutErrors, UpdateAuthorizationUserUserIdAuthorizationPutResponses, UpdateSelfPreferencesUserMePreferencesPatchData, UpdateSelfPreferencesUserMePreferencesPatchErrors, UpdateSelfPreferencesUserMePreferencesPatchResponses, UpdateSelfUserMePutData, UpdateSelfUserMePutErrors, UpdateSelfUserMePutResponses, ValidateInvitationUserInvitationValidatePostData, ValidateInvitationUserInvitationValidatePostErrors, ValidateInvitationUserInvitationValidatePostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Oauth Metadata
 *
 * OAuth2 discovery endpoint.
 *
 * Returns server metadata according to RFC 8414.
 * This endpoint provides information about the OAuth server's capabilities.
 */
export const getOauthMetadataWellKnownOauthAuthorizationServerGet = <ThrowOnError extends boolean = false>(options?: Options<GetOauthMetadataWellKnownOauthAuthorizationServerGetData, ThrowOnError>) => (options?.client ?? client).get<GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses, unknown, ThrowOnError>({ url: '/.well-known/oauth-authorization-server', ...options });

/**
 * Get Oauth Protected Resource Metadata
 *
 * OAuth2 protected resource metadata endpoint.
 *
 * Returns protected resource metadata according to RFC 9728.
 * This endpoint allows OAuth clients to discover which authorization servers
 * this protected resource trusts and what scopes it supports.
 */
export const getOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGet = <ThrowOnError extends boolean = false>(options?: Options<GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetData, ThrowOnError>) => (options?.client ?? client).get<GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses, unknown, ThrowOnError>({ url: '/.well-known/oauth-protected-resource', ...options });

/**
 * Start
 *
 * Get activity metrics for all organizations user has access to.
 *
 * Requires ORGANIZATION_MANAGER role in at least one organization.
 *
 * Args:
 * since_days: Lookback period (1-365 days)
 * include_user_details: Include per-user activity breakdown
 */
export const startOrganizationActivityMetricsGetOrganizationActivityStartGet = <ThrowOnError extends boolean = false>(options?: Options<StartOrganizationActivityMetricsGetOrganizationActivityStartGetData, ThrowOnError>) => (options?.client ?? client).get<StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses, StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/organization/activity_metrics/get_organization_activity/start',
    ...options
});

/**
 * Start
 *
 * Get a list of organizations that current logged-in user has access to.
 */
export const startOrganizationOrganizationMgtGetOrganizationsStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartOrganizationOrganizationMgtGetOrganizationsStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/organization/organization_mgt/get_organizations/start',
    ...options
});

/**
 * Start
 *
 * Get Domain
 */
export const startOrganizationOrganizationMgtGetOrganizationByNameStartPost = <ThrowOnError extends boolean = false>(options: Options<StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData, ThrowOnError>) => (options.client ?? client).post<StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/organization/organization_mgt/get_organization_by_name/start',
    ...options
});

/**
 * Start
 *
 * Add artefact group to an entity
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * name: str - The name of the artefact group
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementAddArtefactGroupStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementAddArtefactGroupStartPostResponses, StartBizArtefactManagementAddArtefactGroupStartPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/add_artefact_group/start',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Start
 *
 * Remove an Artefact group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact group to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRemoveArtefactGroupStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementRemoveArtefactGroupStartPostResponses, StartBizArtefactManagementRemoveArtefactGroupStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/remove_artefact_group/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update an Artefact. Any parameters given will be updated.
 *
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update.
 * content: File - The file contents to update.
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}".
 * user_email: str - The email of the user making the request.
 */
export const startBizArtefactManagementUpdateArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementUpdateArtefactStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementUpdateArtefactStartPostResponses, StartBizArtefactManagementUpdateArtefactStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/update_artefact/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Add an artefact to an entity.
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementAddArtefactStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementAddArtefactStartPostResponses, StartBizArtefactManagementAddArtefactStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/add_artefact/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get artefact tree for given Entity containing directories and files
 */
export const startBizArtefactManagementGetArtefactsTreeStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetArtefactsTreeStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementGetArtefactsTreeStartPostResponses, StartBizArtefactManagementGetArtefactsTreeStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/get_artefacts_tree/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Remove an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRemoveArtefactStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementRemoveArtefactStartPostResponses, StartBizArtefactManagementRemoveArtefactStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/remove_artefact/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get the history of a given artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to get the history of
 * - limit?: int - The maximum number of history items to return, defaults to 10
 * - offset?: int - The number of history items to skip, defaults to 0
 */
export const startBizArtefactManagementGetHistoryStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetHistoryStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementGetHistoryStartPostResponses, StartBizArtefactManagementGetHistoryStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/get_history/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Rename an Artefact Group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact Group to rename
 * - name: str - The new name of the Artefact Group
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRenameArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRenameArtefactGroupStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementRenameArtefactGroupStartPostResponses, StartBizArtefactManagementRenameArtefactGroupStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/rename_artefact_group/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get the artefact in the given location
 *
 * Request params:
 * - artefact_id: str - The identity of the artefact to get
 * - revision: str - Optional revision of the artefact to get
 */
export const startBizArtefactManagementGetArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetArtefactStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementGetArtefactStartPostResponses, StartBizArtefactManagementGetArtefactStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/get_artefact/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Restore an Artefact from the history.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - revision?: str - The revision to restore the artefact from
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRestoreHistoricalArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRestoreHistoricalArtefactStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponses, StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/restore_historical_artefact/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Rename an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to rename
 * - name: str - The new name of the Artefact
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 *
 * @deprecated
 */
export const startBizArtefactManagementRenameArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRenameArtefactStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementRenameArtefactStartPostResponses, StartBizArtefactManagementRenameArtefactStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/rename_artefact/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Add a file artefact to an entity
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 *
 * @deprecated
 */
export const startBizArtefactManagementUpdateArtefactContentStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementUpdateArtefactContentStartPostData, ThrowOnError>) => (options.client ?? client).post<StartBizArtefactManagementUpdateArtefactContentStartPostResponses, StartBizArtefactManagementUpdateArtefactContentStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/artefact_management/update_artefact_content/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get entity info
 */
export const startBizEntitiesEntityTypeEntityIdInfoGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdInfoGetData, ThrowOnError>) => (options.client ?? client).get<StartBizEntitiesEntityTypeEntityIdInfoGetResponses, StartBizEntitiesEntityTypeEntityIdInfoGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/entities/{entity_type}/{entity_id}/info',
    ...options
});

/**
 * Start
 *
 * Get the entity in the given location using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 */
export const startBizEntitiesEntityTypeEntityIdAttributeGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeGetData, ThrowOnError>) => (options.client ?? client).get<StartBizEntitiesEntityTypeEntityIdAttributeGetResponses, StartBizEntitiesEntityTypeEntityIdAttributeGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}',
    ...options
});

/**
 * Start
 *
 * Get the entity history using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - limit: int - The number of history items to return
 * - offset: int - The number of history items to skip
 */
export const startBizEntitiesEntityTypeEntityIdAttributeHistoryGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData, ThrowOnError>) => (options.client ?? client).get<StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/history',
    ...options
});

/**
 * Start
 *
 * Restore an entity to a previous version.
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - revision: str - The revision to restore
 */
export const startBizEntitiesEntityTypeEntityIdAttributeRestorePost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData, ThrowOnError>) => (options.client ?? client).post<StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponses, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/restore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Generate an entity description
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 */
export const startBizEntitiesEntityTypeEntityIdGenerateDescriptionPost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData, ThrowOnError>) => (options.client ?? client).sse.post<StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/entities/{entity_type}/{entity_id}/generate_description',
    ...options
});

/**
 * Start
 *
 * Generate an entity children based on the context available.
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 */
export const startBizEntitiesEntityTypeEntityIdGenerateChildrenPost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData, ThrowOnError>) => (options.client ?? client).post<StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponses, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/biz/entities/{entity_type}/{entity_id}/generate_children',
    ...options
});

/**
 * Start
 *
 * Get Workspace by Stek
 */
export const startWorkspaceWorktreeMgtGetWorktreeStartPost = <ThrowOnError extends boolean = false>(options: Options<StartWorkspaceWorktreeMgtGetWorktreeStartPostData, ThrowOnError>) => (options.client ?? client).post<StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses, StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/workspace/worktree_mgt/get_worktree/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Create a new release by tagging all domains in the stek.
 */
export const startStekStekReleaseMgtCreateReleaseStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekReleaseMgtCreateReleaseStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekReleaseMgtCreateReleaseStartPostResponses, StartStekStekReleaseMgtCreateReleaseStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_release_mgt/create_release/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get diff between two releases (or HEAD to a release).
 */
export const startStekStekReleaseMgtGetReleaseDiffStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekReleaseMgtGetReleaseDiffStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekReleaseMgtGetReleaseDiffStartPostResponses, StartStekStekReleaseMgtGetReleaseDiffStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_release_mgt/get_release_diff/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get a specific release by name.
 */
export const startStekStekReleaseMgtGetReleaseStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekReleaseMgtGetReleaseStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekReleaseMgtGetReleaseStartPostResponses, StartStekStekReleaseMgtGetReleaseStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_release_mgt/get_release/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * List all releases for a stek.
 */
export const startStekStekReleaseMgtListReleasesStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekReleaseMgtListReleasesStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekStekReleaseMgtListReleasesStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_release_mgt/list_releases/start',
    ...options
});

/**
 * Start
 *
 * Get tree for given Stek containing all directories and files
 */
export const startStekStekMgtTreeStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtTreeStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekStekMgtTreeStartPostResponses, StartStekStekMgtTreeStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/tree/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Start
 *
 * Get Steks by Organization
 */
export const startStekStekMgtGetSteksByOrganizationStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtGetSteksByOrganizationStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekStekMgtGetSteksByOrganizationStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/get_steks_by_organization/start',
    ...options
});

/**
 * Start
 *
 * Update a Stek's management settings: name, live mode, and compliance.
 */
export const startStekStekMgtManageStekStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtManageStekStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekMgtManageStekStartPostResponses, StartStekStekMgtManageStekStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/manage_stek/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Create a new Stek with optional logo, FQDN, and description
 */
export const startStekStekMgtCreateStekStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtCreateStekStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekMgtCreateStekStartPostResponses, StartStekStekMgtCreateStekStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/create_stek/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Export a Stek as a ZIP file.
 */
export const startStekStekMgtExportStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtExportStekStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekStekMgtExportStekStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/export_stek/start',
    ...options
});

/**
 * Start
 *
 * Generate stek details based on the context available.
 */
export const startStekStekMgtGenerateStekDetailsStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtGenerateStekDetailsStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekMgtGenerateStekDetailsStartPostResponses, StartStekStekMgtGenerateStekDetailsStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/generate_stek_details/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Import a Stek from a ZIP file.
 */
export const startStekStekMgtImportStekStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtImportStekStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekMgtImportStekStartPostResponses, StartStekStekMgtImportStekStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/import_stek/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Update a Stek's content: logo, description, mission, vision, and related text fields.
 */
export const startStekStekMgtUpdateStekStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtUpdateStekStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekStekMgtUpdateStekStartPostResponses, StartStekStekMgtUpdateStekStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/update_stek/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Stek
 */
export const startStekStekMgtGetStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtGetStekStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekStekMgtGetStekStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/get_stek/start',
    ...options
});

/**
 * Start
 *
 * Delete a STek
 */
export const startStekStekMgtDeleteStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtDeleteStekStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekStekMgtDeleteStekStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/stek_mgt/delete_stek/start',
    ...options
});

/**
 * Delete Integration Settings
 *
 * Delete integration settings for the current organization.
 *
 * Args:
 * integration_type: The integration you want to delete
 */
export const deleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteResponses, DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/integration_mgt/integration/settings/{integration_type}',
    ...options
});

/**
 * Get Integration Settings
 *
 * Get integration settings for the current organization.
 *
 * Args:
 * integration_type: The integration you want to get
 *
 * Returns:
 * Integration
 *
 * Raises:
 * HTTPException: If organization not found or settings not configured
 */
export const getIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGet = <ThrowOnError extends boolean = false>(options: Options<GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetData, ThrowOnError>) => (options.client ?? client).get<GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses, GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/integration_mgt/integration/settings/{integration_type}',
    ...options
});

/**
 * Create Api Integration
 *
 * Create an API integration
 *
 * Args:
 * integration_type: The integration you want to save
 * api_key: The API key for the integration
 */
export const createApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePost = <ThrowOnError extends boolean = false>(options: Options<CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostData, ThrowOnError>) => (options.client ?? client).post<CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses, CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/integration_mgt/integration/settings/{integration_type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Integration Connection
 *
 * Test integration connection with provided credentials.
 *
 * Args:
 * integration_type: The integration type to test
 * api_key: The API key for the integration
 * host: Optional custom host URL
 *
 * Returns:
 * Connection test result
 *
 * Raises:
 * HTTPException: If the connection test fails
 */
export const testIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePost = <ThrowOnError extends boolean = false>(options: Options<TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostData, ThrowOnError>) => (options.client ?? client).post<TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostResponses, TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/integration_mgt/integration/test/{integration_type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get all unique releases for a given Stek
 */
export const startStekLiveMgtGetReleasesStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekLiveMgtGetReleasesStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekLiveMgtGetReleasesStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/live_mgt/get_releases/start',
    ...options
});

/**
 * Start
 *
 * Ingest an event from a running Stek.
 *
 * This endpoint is designed to be flexible:
 * - Only `stek_release` is strictly required.
 * - If `process_element_id`, `process_id`, or `product_id` is provided, the backend
 * automatically resolves the full parent hierarchy (Domain, Product, Process).
 * - If `timestamp` is omitted, it defaults to the current UTC time.
 * - `event_type` defaults to 'generic.event' and `payload` to an empty object if not specified.
 *
 * Payload structure:
 * - Can contain any arbitrary data (extra fields allowed)
 * - If including compliance evidence, use the `compliance_proof` structure:
 * {
 * "compliance_proof": {
 * "evidence": [
 * {
 * "id": "evidence_123",
 * "type": "uri",  // or "description"
 * "value": "https://...",  // URL for uri, text for description
 * "description": "What this proves",
 * "timestamp": "2026-01-31T10:30:00Z",
 * "created_by": "user@example.com"  // optional
 * }
 * ],
 * "metadata": {}  // optional
 * },
 * "custom_field": "any other data"
 * }
 */
export const startStekLiveMgtIngestEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekLiveMgtIngestEventStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekLiveMgtIngestEventStartPostResponses, StartStekLiveMgtIngestEventStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/live_mgt/ingest_event/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get all compliance evidence for a process instance.
 *
 * Returns all compliance evidence items with their event context:
 * - Evidence details (type, value, description, timestamp)
 * - Event context (event_id, event_type, business_key)
 */
export const startStekLiveMgtGetComplianceEvidenceStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekLiveMgtGetComplianceEvidenceStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekLiveMgtGetComplianceEvidenceStartPostResponses, StartStekLiveMgtGetComplianceEvidenceStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/live_mgt/get_compliance_evidence/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get runtime metrics for all instances of a process.
 *
 * Returns aggregated metrics for each process instance, including:
 * - Start time and last event time
 * - Duration (if completed)
 * - Total events and event types
 * - Error count and status (running/completed/failed)
 */
export const startStekLiveMgtGetProcessInstancesStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekLiveMgtGetProcessInstancesStartPostData, ThrowOnError>) => (options.client ?? client).post<StartStekLiveMgtGetProcessInstancesStartPostResponses, StartStekLiveMgtGetProcessInstancesStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/live_mgt/get_process_instances/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get aggregated metrics for a Stek, Domain, Product, or Process.
 *
 * Exactly one of stek_id, domain_id, product_id, or process_id must be provided.
 */
export const startStekLiveMgtGetMetricsStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekLiveMgtGetMetricsStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartStekLiveMgtGetMetricsStartPostResponses, StartStekLiveMgtGetMetricsStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/stek/live_mgt/get_metrics/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Start
 *
 * Get Product
 */
export const startProductProductMgtGetProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtGetProductStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProductProductMgtGetProductStartPostResponses, StartProductProductMgtGetProductStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/product/product_mgt/get_product/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Move a product to a new domain.
 */
export const startProductProductMgtMoveProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtMoveProductStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProductProductMgtMoveProductStartPostResponses, StartProductProductMgtMoveProductStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/product/product_mgt/move_product/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update a Product
 */
export const startProductProductMgtUpdateProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtUpdateProductStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProductProductMgtUpdateProductStartPostResponses, StartProductProductMgtUpdateProductStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/product/product_mgt/update_product/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete a Product
 */
export const startProductProductMgtDeleteProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtDeleteProductStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProductProductMgtDeleteProductStartPostResponses, StartProductProductMgtDeleteProductStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/product/product_mgt/delete_product/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Create a new Product
 */
export const startProductProductMgtCreateProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtCreateProductStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProductProductMgtCreateProductStartPostResponses, StartProductProductMgtCreateProductStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/product/product_mgt/create_product/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Update product orders.
 */
export const startProductProductMgtUpdateProductOrdersStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtUpdateProductOrdersStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProductProductMgtUpdateProductOrdersStartPostResponses, StartProductProductMgtUpdateProductOrdersStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/product/product_mgt/update_product_orders/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Products by Domain
 */
export const startProductProductMgtGetProductsByDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtGetProductsByDomainStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProductProductMgtGetProductsByDomainStartPostResponses, StartProductProductMgtGetProductsByDomainStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/product/product_mgt/get_products_by_domain/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Dashboards by Stek
 */
export const startDashboardDashboardMgtGetDashboardsByStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartDashboardDashboardMgtGetDashboardsByStekStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartDashboardDashboardMgtGetDashboardsByStekStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/dashboard/dashboard_mgt/get_dashboards_by_stek/start',
    ...options
});

/**
 * Start
 *
 * Update a specific dashboard.
 */
export const startDashboardDashboardMgtUpdateDashboardStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDashboardDashboardMgtUpdateDashboardStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDashboardDashboardMgtUpdateDashboardStartPostResponses, StartDashboardDashboardMgtUpdateDashboardStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/dashboard/dashboard_mgt/update_dashboard/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete a Domain
 */
export const startDomainDomainMgtDeleteDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtDeleteDomainStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainDomainMgtDeleteDomainStartPostResponses, StartDomainDomainMgtDeleteDomainStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/domain_mgt/delete_domain/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Domains by Stek
 */
export const startDomainDomainMgtGetDomainsByStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartDomainDomainMgtGetDomainsByStekStartPostData, ThrowOnError>) => (options?.client ?? client).post<StartDomainDomainMgtGetDomainsByStekStartPostResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/domain_mgt/get_domains_by_stek/start',
    ...options
});

/**
 * Start
 *
 * Update a domain.
 */
export const startDomainDomainMgtUpdateDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtUpdateDomainStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainDomainMgtUpdateDomainStartPostResponses, StartDomainDomainMgtUpdateDomainStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/domain_mgt/update_domain/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Domain
 */
export const startDomainDomainMgtGetDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtGetDomainStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainDomainMgtGetDomainStartPostResponses, StartDomainDomainMgtGetDomainStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/domain_mgt/get_domain/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update domain orders.
 */
export const startDomainDomainMgtUpdateDomainOrdersStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtUpdateDomainOrdersStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainDomainMgtUpdateDomainOrdersStartPostResponses, StartDomainDomainMgtUpdateDomainOrdersStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/domain_mgt/update_domain_orders/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Create a new Domain
 */
export const startDomainDomainMgtCreateDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtCreateDomainStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainDomainMgtCreateDomainStartPostResponses, StartDomainDomainMgtCreateDomainStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/domain_mgt/create_domain/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Update a business entity details and/or definition.
 *
 * This endpoint supports multipart/form-data for file uploads (description, definition)
 * and JSON data for relationships. The relationships parameter should be a JSON.stringify()
 * of an array of relationship objects.
 *
 * The relationships JSON structure should match the BusinessEntityRelationshipsFormData schema.
 */
export const startDomainBusinessEntityMgtUpdateBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponses, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/business_entity_mgt/update_business_entity/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get a business entity.
 */
export const startDomainBusinessEntityMgtGetBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtGetBusinessEntityStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses, StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/business_entity_mgt/get_business_entity/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Create a new business entity.
 *
 * This endpoint supports multipart/form-data for file uploads (description, definition)
 * and JSON data for relationships. The relationships parameter should be a JSON.stringify()
 * of an array of relationship objects.
 *
 * The relationships JSON structure should match the BusinessEntityRelationshipsFormData schema.
 */
export const startDomainBusinessEntityMgtCreateBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponses, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/business_entity_mgt/create_business_entity/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete a business entity.
 */
export const startDomainBusinessEntityMgtDeleteBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponses, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/business_entity_mgt/delete_business_entity/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get a list of business entities belonging to a domain
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/business_entity_mgt/get_business_entities/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get all Role(s) for provided Domain
 */
export const startDomainRoleMgtGetRolesStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtGetRolesStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainRoleMgtGetRolesStartPostResponses, StartDomainRoleMgtGetRolesStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/role_mgt/get_roles/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Create Role in Domain
 */
export const startDomainRoleMgtCreateRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtCreateRoleStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainRoleMgtCreateRoleStartPostResponses, StartDomainRoleMgtCreateRoleStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/role_mgt/create_role/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Update a Role.
 */
export const startDomainRoleMgtUpdateRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtUpdateRoleStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainRoleMgtUpdateRoleStartPostResponses, StartDomainRoleMgtUpdateRoleStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/role_mgt/update_role/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete Role
 */
export const startDomainRoleMgtDeleteRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtDeleteRoleStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainRoleMgtDeleteRoleStartPostResponses, StartDomainRoleMgtDeleteRoleStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/role_mgt/delete_role/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Role
 */
export const startDomainRoleMgtGetRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtGetRoleStartPostData, ThrowOnError>) => (options.client ?? client).post<StartDomainRoleMgtGetRoleStartPostResponses, StartDomainRoleMgtGetRoleStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/domain/role_mgt/get_role/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Lane
 */
export const startProcessLaneMgtGetLaneStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessLaneMgtGetLaneStartPostResponses, StartProcessLaneMgtGetLaneStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/lane_mgt/get_lane/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Lane by Role Id.
 */
export const startProcessLaneMgtGetLaneByRoleIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneByRoleIdStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessLaneMgtGetLaneByRoleIdStartPostResponses, StartProcessLaneMgtGetLaneByRoleIdStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/lane_mgt/get_lane_by_role_id/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Lane by BPMN ID.
 */
export const startProcessLaneMgtGetLaneByBpmnIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneByBpmnIdStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses, StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/lane_mgt/get_lane_by_bpmn_id/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Lanes by Process.
 */
export const startProcessLaneMgtGetLanesByProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLanesByProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessLaneMgtGetLanesByProcessStartPostResponses, StartProcessLaneMgtGetLanesByProcessStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/lane_mgt/get_lanes_by_process/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Process Element by BPMN ID.
 */
export const startProcessProcessElementMgtGetProcessElementByBpmnIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/get_process_element_by_bpmn_id/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete Gateway
 */
export const startProcessProcessElementMgtDeleteGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteGatewayStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtDeleteGatewayStartPostResponses, StartProcessProcessElementMgtDeleteGatewayStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/delete_gateway/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update event.
 */
export const startProcessProcessElementMgtUpdateEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateEventStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtUpdateEventStartPostResponses, StartProcessProcessElementMgtUpdateEventStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/update_event/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Tasks by Process.
 */
export const startProcessProcessElementMgtGetProcessElementsByProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/get_process_elements_by_process/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Generate a React component for a process element.
 */
export const startProcessProcessElementMgtGenerateUserInterfaceStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGenerateUserInterfaceStartPostData, ThrowOnError>) => (options.client ?? client).sse.post<StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses, StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/generate_user_interface/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update gateway.
 */
export const startProcessProcessElementMgtUpdateGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateGatewayStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtUpdateGatewayStartPostResponses, StartProcessProcessElementMgtUpdateGatewayStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/update_gateway/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Event.
 */
export const startProcessProcessElementMgtGetEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetEventStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtGetEventStartPostResponses, StartProcessProcessElementMgtGetEventStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/get_event/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Unarchive Process Element.
 */
export const startProcessProcessElementMgtUnarchiveProcessElementStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUnarchiveProcessElementStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponses, StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/unarchive_process_element/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete Event
 */
export const startProcessProcessElementMgtDeleteEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteEventStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtDeleteEventStartPostResponses, StartProcessProcessElementMgtDeleteEventStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/delete_event/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Archive Task
 */
export const startProcessProcessElementMgtArchiveProcessElementStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtArchiveProcessElementStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtArchiveProcessElementStartPostResponses, StartProcessProcessElementMgtArchiveProcessElementStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/archive_process_element/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete Task
 */
export const startProcessProcessElementMgtDeleteTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteTaskStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtDeleteTaskStartPostResponses, StartProcessProcessElementMgtDeleteTaskStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/delete_task/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Task.
 */
export const startProcessProcessElementMgtGetTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetTaskStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtGetTaskStartPostResponses, StartProcessProcessElementMgtGetTaskStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/get_task/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update flow.
 */
export const startProcessProcessElementMgtUpdateFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateFlowStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtUpdateFlowStartPostResponses, StartProcessProcessElementMgtUpdateFlowStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/update_flow/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Gateway.
 */
export const startProcessProcessElementMgtGetGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetGatewayStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtGetGatewayStartPostResponses, StartProcessProcessElementMgtGetGatewayStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/get_gateway/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update task.
 */
export const startProcessProcessElementMgtUpdateTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateTaskStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtUpdateTaskStartPostResponses, StartProcessProcessElementMgtUpdateTaskStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/update_task/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Flow.
 */
export const startProcessProcessElementMgtGetFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetFlowStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtGetFlowStartPostResponses, StartProcessProcessElementMgtGetFlowStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/get_flow/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete Flow
 */
export const startProcessProcessElementMgtDeleteFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteFlowStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessElementMgtDeleteFlowStartPostResponses, StartProcessProcessElementMgtDeleteFlowStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_element_mgt/delete_flow/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update process orders.
 */
export const startProcessProcessMgtUpdateProcessOrdersStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtUpdateProcessOrdersStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtUpdateProcessOrdersStartPostResponses, StartProcessProcessMgtUpdateProcessOrdersStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/update_process_orders/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Process
 */
export const startProcessProcessMgtGetProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGetProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtGetProcessStartPostResponses, StartProcessProcessMgtGetProcessStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/get_process/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Move a Process to a new Product.
 */
export const startProcessProcessMgtMoveProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtMoveProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtMoveProcessStartPostResponses, StartProcessProcessMgtMoveProcessStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/move_process/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Deploy a Process to process engine.
 *
 * Returns:
 * resp (dict): Of the form:
 * {'deployment_id': str}
 */
export const startProcessProcessMgtDeployProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtDeployProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtDeployProcessStartPostResponses, StartProcessProcessMgtDeployProcessStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/deploy_process/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Update a process.
 */
export const startProcessProcessMgtUpdateProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtUpdateProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtUpdateProcessStartPostResponses, StartProcessProcessMgtUpdateProcessStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/update_process/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Delete a Process
 */
export const startProcessProcessMgtDeleteProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtDeleteProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtDeleteProcessStartPostResponses, StartProcessProcessMgtDeleteProcessStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/delete_process/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Create a new Process
 */
export const startProcessProcessMgtCreateProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtCreateProcessStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtCreateProcessStartPostResponses, StartProcessProcessMgtCreateProcessStartPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/create_process/start',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start
 *
 * Get Processes by Product.
 */
export const startProcessProcessMgtGetProcessesByProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGetProcessesByProductStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtGetProcessesByProductStartPostResponses, StartProcessProcessMgtGetProcessesByProductStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/get_processes_by_product/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Generate a Process definition as raw BPMN XML.
 */
export const startProcessProcessMgtGenerateDefinitionXmlStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGenerateDefinitionXmlStartPostData, ThrowOnError>) => (options.client ?? client).post<StartProcessProcessMgtGenerateDefinitionXmlStartPostResponses, StartProcessProcessMgtGenerateDefinitionXmlStartPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/process/process_mgt/generate_definition_xml/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Users
 *
 * Get all users.
 */
export const getUsersUserGet = <ThrowOnError extends boolean = false>(options?: Options<GetUsersUserGetData, ThrowOnError>) => (options?.client ?? client).get<GetUsersUserGetResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/',
    ...options
});

/**
 * Create User
 *
 * Create a user.
 */
export const createUserUserPost = <ThrowOnError extends boolean = false>(options: Options<CreateUserUserPostData, ThrowOnError>) => (options.client ?? client).post<CreateUserUserPostResponses, CreateUserUserPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signup
 *
 * Create a new user account with policy acceptance.
 *
 * This endpoint is idempotent - calling it multiple times with the same
 * email will succeed if the user is fully created.
 *
 * Note: Uses ctx directly instead of service.execute() because the user
 * may not exist yet during signup (service.execute() calls current_user()
 * which would try to auto-create from Firebase).
 */
export const signupUserSignupPost = <ThrowOnError extends boolean = false>(options: Options<SignupUserSignupPostData, ThrowOnError>) => (options.client ?? client).post<SignupUserSignupPostResponses, SignupUserSignupPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate Invitation
 *
 * Validate an invitation token and return invitation details.
 *
 * This endpoint is unauthenticated - the user hasn't created their account yet.
 *
 * Args:
 * request: Request body containing the encrypted invitation token
 *
 * Returns:
 * InvitationValidation with email and organization name
 */
export const validateInvitationUserInvitationValidatePost = <ThrowOnError extends boolean = false>(options: Options<ValidateInvitationUserInvitationValidatePostData, ThrowOnError>) => (options.client ?? client).post<ValidateInvitationUserInvitationValidatePostResponses, ValidateInvitationUserInvitationValidatePostErrors, ThrowOnError>({
    url: '/user/invitation/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signup With Invitation
 *
 * Create a new user account via invitation.
 *
 * This endpoint is idempotent - calling it multiple times with the same
 * email will succeed if the user is fully created and authorized.
 *
 * Note: Uses ctx directly instead of service.execute() because the user
 * may not exist yet during signup (service.execute() calls current_user()
 * which would try to auto-create from Firebase).
 */
export const signupWithInvitationUserSignupWithInvitationPost = <ThrowOnError extends boolean = false>(options: Options<SignupWithInvitationUserSignupWithInvitationPostData, ThrowOnError>) => (options.client ?? client).post<SignupWithInvitationUserSignupWithInvitationPostResponses, SignupWithInvitationUserSignupWithInvitationPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/signup-with-invitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Invitation Endpoint
 *
 * Resend invitation to a user with expired invitation token.
 *
 * Only works for users with INVITATION_EXPIRED status.
 * Generates a new token and sends a new invitation email.
 */
export const resendInvitationEndpointUserUserIdResendInvitationPost = <ThrowOnError extends boolean = false>(options: Options<ResendInvitationEndpointUserUserIdResendInvitationPostData, ThrowOnError>) => (options.client ?? client).post<ResendInvitationEndpointUserUserIdResendInvitationPostResponses, ResendInvitationEndpointUserUserIdResendInvitationPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/{user_id}/resend-invitation',
    ...options
});

/**
 * Delete User
 *
 * Delete a User.
 */
export const deleteUserUserUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteUserUserUserIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserUserUserIdDeleteResponses, DeleteUserUserUserIdDeleteErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/{user_id}',
    ...options
});

/**
 * Get Self
 *
 * Get currently logged in user.
 */
export const getSelfUserMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetSelfUserMeGetData, ThrowOnError>) => (options?.client ?? client).get<GetSelfUserMeGetResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/me',
    ...options
});

/**
 * Update Self
 *
 * Update current user's profile.
 */
export const updateSelfUserMePut = <ThrowOnError extends boolean = false>(options: Options<UpdateSelfUserMePutData, ThrowOnError>) => (options.client ?? client).put<UpdateSelfUserMePutResponses, UpdateSelfUserMePutErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Self Preferences
 *
 * Update current user's hint/UI preferences (patch semantics).
 */
export const updateSelfPreferencesUserMePreferencesPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateSelfPreferencesUserMePreferencesPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateSelfPreferencesUserMePreferencesPatchResponses, UpdateSelfPreferencesUserMePreferencesPatchErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/me/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Domain Roles
 *
 * Get roles for given domain.
 */
export const getDomainRolesUserUserIdDomainRolesGet = <ThrowOnError extends boolean = false>(options: Options<GetDomainRolesUserUserIdDomainRolesGetData, ThrowOnError>) => (options.client ?? client).get<GetDomainRolesUserUserIdDomainRolesGetResponses, GetDomainRolesUserUserIdDomainRolesGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/{user_id}/domain-roles',
    ...options
});

/**
 * Update Authorization
 *
 * Set the full list of roles for a user in the organization.
 */
export const updateAuthorizationUserUserIdAuthorizationPut = <ThrowOnError extends boolean = false>(options: Options<UpdateAuthorizationUserUserIdAuthorizationPutData, ThrowOnError>) => (options.client ?? client).put<UpdateAuthorizationUserUserIdAuthorizationPutResponses, UpdateAuthorizationUserUserIdAuthorizationPutErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/{user_id}/authorization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Api Keys
 *
 * List all API keys for the current user in the current organization.
 */
export const listApiKeysUserApiKeysGet = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysUserApiKeysGetData, ThrowOnError>) => (options?.client ?? client).get<ListApiKeysUserApiKeysGetResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/api-keys',
    ...options
});

/**
 * Create Api Key
 *
 * Create a new API key for the current user in the current organization.
 */
export const createApiKeyUserApiKeyPost = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyUserApiKeyPostData, ThrowOnError>) => (options.client ?? client).post<CreateApiKeyUserApiKeyPostResponses, CreateApiKeyUserApiKeyPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/api-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Api Key
 *
 * Revoke an API key.
 */
export const revokeApiKeyUserApiKeyApiKeyIdDelete = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyUserApiKeyApiKeyIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses, RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/api-key/{api_key_id}',
    ...options
});

/**
 * Record Policy Acceptance
 *
 * Record user acceptance of a policy.
 */
export const recordPolicyAcceptanceUserPolicyAcceptancePost = <ThrowOnError extends boolean = false>(options: Options<RecordPolicyAcceptanceUserPolicyAcceptancePostData, ThrowOnError>) => (options.client ?? client).post<RecordPolicyAcceptanceUserPolicyAcceptancePostResponses, RecordPolicyAcceptanceUserPolicyAcceptancePostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/policy-acceptance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Policy Acceptances
 *
 * Get policy acceptance history for the current user.
 */
export const getPolicyAcceptancesUserPolicyAcceptancesGet = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyAcceptancesUserPolicyAcceptancesGetData, ThrowOnError>) => (options?.client ?? client).get<GetPolicyAcceptancesUserPolicyAcceptancesGetResponses, GetPolicyAcceptancesUserPolicyAcceptancesGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/policy-acceptances',
    ...options
});

/**
 * Get Policy Status
 *
 * Get current policy acceptance status for the user.
 */
export const getPolicyStatusUserPolicyStatusGet = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyStatusUserPolicyStatusGetData, ThrowOnError>) => (options?.client ?? client).get<GetPolicyStatusUserPolicyStatusGetResponses, unknown, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/policy-status',
    ...options
});

/**
 * Get All Platform Users
 *
 * Get all users across all organizations (platform-wide).
 *
 * Requires ORGANIZATION_MANAGER role. Returns all MyStekz platform users.
 *
 * Note:
 * - This is a platform-wide operation showing all registered users.
 * - To get Firebase authentication details for a specific user, use GET /user/firebase/{email}.
 */
export const getAllPlatformUsersUserAllGet = <ThrowOnError extends boolean = false>(options?: Options<GetAllPlatformUsersUserAllGetData, ThrowOnError>) => (options?.client ?? client).get<GetAllPlatformUsersUserAllGetResponses, GetAllPlatformUsersUserAllGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/all/',
    ...options
});

/**
 * Get Firebase User By Email
 *
 * Get Firebase authentication details for a user by email.
 *
 * Requires ORGANIZATION_MANAGER role (platform-wide). Returns Firebase user details
 * including MFA settings.
 *
 * Args:
 * email: The user's email address.
 *
 * Returns:
 * Firebase user record with authentication details and MFA enrollments.
 */
export const getFirebaseUserByEmailUserFirebaseEmailGet = <ThrowOnError extends boolean = false>(options: Options<GetFirebaseUserByEmailUserFirebaseEmailGetData, ThrowOnError>) => (options.client ?? client).get<GetFirebaseUserByEmailUserFirebaseEmailGetResponses, GetFirebaseUserByEmailUserFirebaseEmailGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/user/firebase/{email}',
    ...options
});

/**
 * Start
 *
 * Get the supported providers for a specific task type.
 *
 * Args:
 * request: The request containing the task type to get providers for
 *
 * Returns:
 * A SupportedProvidersResponse containing the list of supported providers
 */
export const startAiTaskMgtGetTaskProvidersStartPost = <ThrowOnError extends boolean = false>(options: Options<StartAiTaskMgtGetTaskProvidersStartPostData, ThrowOnError>) => (options.client ?? client).post<StartAiTaskMgtGetTaskProvidersStartPostResponses, StartAiTaskMgtGetTaskProvidersStartPostErrors, ThrowOnError>({
    url: '/ai/task_mgt/get_task_providers/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * List task evaluations for a specific task name.
 *
 * Args:
 * request: The request containing the task name to filter evaluations by
 *
 * Returns:
 * A TaskEvaluationListResponse containing matching evaluation results.
 */
export const startAiEvaluationGetTaskEvaluationsStartPost = <ThrowOnError extends boolean = false>(options: Options<StartAiEvaluationGetTaskEvaluationsStartPostData, ThrowOnError>) => (options.client ?? client).post<StartAiEvaluationGetTaskEvaluationsStartPostResponses, StartAiEvaluationGetTaskEvaluationsStartPostErrors, ThrowOnError>({
    url: '/ai/evaluation/get_task_evaluations/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start
 *
 * Run a task evaluation and return the result as a streaming response.
 *
 * Args:
 * request: The task evaluation request containing task type, config, and model settings
 *
 * Returns:
 * A streaming response with the task evaluation results
 */
export const startAiTaskMgtRunTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartAiTaskMgtRunTaskStartPostData, ThrowOnError>) => (options.client ?? client).post<StartAiTaskMgtRunTaskStartPostResponses, StartAiTaskMgtRunTaskStartPostErrors, ThrowOnError>({
    url: '/ai/task_mgt/run_task/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search
 */
export const searchSearchGet = <ThrowOnError extends boolean = false>(options: Options<SearchSearchGetData, ThrowOnError>) => (options.client ?? client).get<SearchSearchGetResponses, SearchSearchGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/search/',
    ...options
});

/**
 * Preview Link
 *
 * Get the metadata from a weblink based on the HTML or API for supported services.
 *
 * Args:
 * url: The URL to preview
 *
 * Returns:
 * LinkPreview with extracted metadata
 *
 * Raises:
 * HTTPException: On error fetching or parsing data
 */
export const previewLinkProxyPreviewLinkGet = <ThrowOnError extends boolean = false>(options: Options<PreviewLinkProxyPreviewLinkGetData, ThrowOnError>) => (options.client ?? client).get<PreviewLinkProxyPreviewLinkGetResponses, PreviewLinkProxyPreviewLinkGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/proxy/preview-link',
    ...options
});

/**
 * Prepare
 *
 * Begin OAuth2 authorization flow.
 *
 * This endpoint is called by the frontend to start the authorization flow.
 * It uses Authlib to generate the authorization URL and redirect the user.
 *
 * Args:
 * integration_type: Type of integration (e.g., "clickup")
 * redirect_uri: The URI to redirect to after authorization (optional)
 *
 * Returns:
 * PrepareResponse with the authorization URL
 *
 * Raises:
 * HTTPException: If organization not found or integration type not supported
 */
export const prepareIntegrationsOauth2ClientPrepareIntegrationTypeGet = <ThrowOnError extends boolean = false>(options: Options<PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetData, ThrowOnError>) => (options.client ?? client).get<PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses, PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/integrations/oauth2/client/prepare/{integration_type}',
    ...options
});

/**
 * Exchange Token
 *
 * Exchange authorization code for an access token.
 *
 * Endpoint used by the frontend to exchange the authorization code for a token.
 *
 * Args:
 * token_request: Contains code, state, integration_type, and redirect_uri from the frontend
 *
 * Returns:
 * JSONResponse with success message
 *
 * Raises:
 * HTTPException: If organization not found, token exchange fails, etc.
 */
export const exchangeTokenIntegrationsOauth2ClientTokenPost = <ThrowOnError extends boolean = false>(options: Options<ExchangeTokenIntegrationsOauth2ClientTokenPostData, ThrowOnError>) => (options.client ?? client).post<ExchangeTokenIntegrationsOauth2ClientTokenPostResponses, ExchangeTokenIntegrationsOauth2ClientTokenPostErrors, ThrowOnError>({
    security: [
        { scheme: 'bearer', type: 'http' },
        { name: 'organization', type: 'apiKey' },
        { name: 'stek', type: 'apiKey' }
    ],
    url: '/integrations/oauth2/client/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorize Request
 *
 * OAuth2 authorization endpoint with enhanced authlib-based client validation.
 *
 * This endpoint validates the authorization request parameters and
 * returns a response with the validated data to be displayed in the frontend.
 * Uses authlib for client validation while maintaining existing flow.
 *
 * Args:
 * client_id: The OAuth client ID
 * response_type: Must be 'code' for authorization code flow
 * redirect_uri: URI to redirect to after authorization
 * scope: Space-separated list of requested scopes
 * state: Optional state parameter for CSRF protection
 * code_challenge: PKCE code challenge
 * code_challenge_method: PKCE code challenge method (S256)
 *
 * Returns:
 * Redirect to frontend authorization page with validated parameters
 */
export const authorizeRequestIntegrationsOauth2ServerAuthorizeGet = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetData, ThrowOnError>) => (options?.client ?? client).get<AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetResponses, AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors, ThrowOnError>({ url: '/integrations/oauth2/server/authorize', ...options });

/**
 * Generate Authorization Code
 *
 * Generate an authorization code after user approval.
 *
 * This endpoint is called by the frontend after the user approves the authorization
 * request. It generates an authorization code and redirects the user back to the
 * client application.
 *
 * Args:
 * organization_id: ID of the organization selected by the user
 * stek_id: ID of the stek selected by the user
 * client_id: The OAuth client ID
 * redirect_uri: URI to redirect to after authorization
 * scope: Space-separated list of requested scopes
 * code_challenge: PKCE code challenge
 * code_challenge_method: PKCE code challenge method (S256)
 * state: Optional state parameter for CSRF protection
 * authorization_token: Bearer token for authentication
 * organization_header: Organization ID from form (fallback for headers)
 * stek_header: Stek ID from form (fallback for headers)
 *
 * Returns:
 * RedirectResponse to the client application with the authorization code
 */
export const generateAuthorizationCodeIntegrationsOauth2ServerAuthorizePost = <ThrowOnError extends boolean = false>(options: Options<GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostData, ThrowOnError>) => (options.client ?? client).post<GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostResponses, GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/integrations/oauth2/server/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Token Endpoint
 *
 * OAuth2 token endpoint.
 *
 * Exchanges authorization codes for access tokens or refreshes tokens.
 * Supports both authorization_code and refresh_token grant types.
 */
export const tokenEndpointIntegrationsOauth2ServerTokenPost = <ThrowOnError extends boolean = false>(options: Options<TokenEndpointIntegrationsOauth2ServerTokenPostData, ThrowOnError>) => (options.client ?? client).post<TokenEndpointIntegrationsOauth2ServerTokenPostResponses, TokenEndpointIntegrationsOauth2ServerTokenPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/integrations/oauth2/server/token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Register Client
 *
 * OAuth2 dynamic client registration endpoint.
 *
 * Stores client registration data securely in Valkey with TTL.
 * The redirect_uris will be validated during authorization to prevent
 * authorization code interception attacks per OAuth2 security requirements.
 *
 * Security measures:
 * - Rate limiting: Max 10 registrations per IP per hour
 * - Client name validation: Length limit, character whitelist, no control chars
 * - Redirect URI validation:
 * - HTTP only allowed for localhost (when enabled in settings)
 * - HTTPS required for non-localhost
 * - Private IP addresses blocked (defense-in-depth)
 * - Cloud metadata endpoints blocked
 * - Control characters rejected
 * - Length limit enforced
 * - Pending registrations expire after 1 hour
 *
 * Error responses follow RFC 7591 format with 'error' and 'error_description'.
 */
export const registerClientIntegrationsOauth2ServerRegisterPost = <ThrowOnError extends boolean = false>(options: Options<RegisterClientIntegrationsOauth2ServerRegisterPostData, ThrowOnError>) => (options.client ?? client).post<RegisterClientIntegrationsOauth2ServerRegisterPostResponses, RegisterClientIntegrationsOauth2ServerRegisterPostErrors, ThrowOnError>({
    url: '/integrations/oauth2/server/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Token
 *
 * OAuth2 token revocation endpoint.
 *
 * Revokes access or refresh tokens to prevent further use.
 * For refresh tokens, revokes both current and previous tokens.
 * Returns 200 OK for successful revocation or invalid tokens per RFC 7009.
 * Returns 400 for malformed requests (e.g., missing required parameters).
 */
export const revokeTokenIntegrationsOauth2ServerRevokePost = <ThrowOnError extends boolean = false>(options: Options<RevokeTokenIntegrationsOauth2ServerRevokePostData, ThrowOnError>) => (options.client ?? client).post<RevokeTokenIntegrationsOauth2ServerRevokePostResponses, RevokeTokenIntegrationsOauth2ServerRevokePostErrors, ThrowOnError>({
    url: '/integrations/oauth2/server/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mcp Streamable Http Handler
 *
 * Handle MCP Streamable HTTP requests.
 *
 * Supports:
 * - POST: Send JSON-RPC messages (with SSE response for streaming)
 * - GET: Establish standalone SSE stream for server-to-client messages
 * - DELETE: Terminate session
 *
 * All requests require OAuth2 authentication via Bearer token.
 */
export const mcpStreamableHttpHandlerIntegrationsMcpPost = <ThrowOnError extends boolean = false>(options?: Options<McpStreamableHttpHandlerIntegrationsMcpPostData, ThrowOnError>) => (options?.client ?? client).delete<McpStreamableHttpHandlerIntegrationsMcpPostResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/integrations/mcp',
    ...options
});

/**
 * Mcp Streamable Http Handler
 *
 * Handle MCP Streamable HTTP requests.
 *
 * Supports:
 * - POST: Send JSON-RPC messages (with SSE response for streaming)
 * - GET: Establish standalone SSE stream for server-to-client messages
 * - DELETE: Terminate session
 *
 * All requests require OAuth2 authentication via Bearer token.
 */
export const mcpStreamableHttpHandlerIntegrationsMcpPost2 = <ThrowOnError extends boolean = false>(options?: Options<McpStreamableHttpHandlerIntegrationsMcpPost2Data, ThrowOnError>) => (options?.client ?? client).get<McpStreamableHttpHandlerIntegrationsMcpPost2Responses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/integrations/mcp',
    ...options
});

/**
 * Mcp Streamable Http Handler
 *
 * Handle MCP Streamable HTTP requests.
 *
 * Supports:
 * - POST: Send JSON-RPC messages (with SSE response for streaming)
 * - GET: Establish standalone SSE stream for server-to-client messages
 * - DELETE: Terminate session
 *
 * All requests require OAuth2 authentication via Bearer token.
 */
export const mcpStreamableHttpHandlerIntegrationsMcpPost3 = <ThrowOnError extends boolean = false>(options?: Options<McpStreamableHttpHandlerIntegrationsMcpPost3Data, ThrowOnError>) => (options?.client ?? client).post<McpStreamableHttpHandlerIntegrationsMcpPost3Responses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/integrations/mcp',
    ...options
});
